import { useNavigate, useParams, Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { EditExpenseForm } from './components/EditExpenseForm';
import { useLanguage } from '../../contexts/LanguageContext';

export default function EditExpensePage() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const expenseId = id ? parseInt(id, 10) : NaN;

  const handleSuccess = () => {
    navigate('/expenses');
  };

  if (!id || Number.isNaN(expenseId)) {
    return (
      <div className="min-h-screen bg-slate-50">
        <header className="bg-white border-b border-slate-200">
          <div className="w-full px-4 sm:px-6 lg:px-8 py-6">
            <Button variant="outline" size="sm" asChild className="border-slate-200">
              <Link to="/expenses">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t('expense.backToExpenses')}
              </Link>
            </Button>
            <p className="text-slate-500 mt-4">{t('expense.invalidId')}</p>
          </div>
        </header>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Button variant="outline" size="sm" asChild className="border-slate-200">
              <Link to="/expenses">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t('expense.backToExpenses')}
              </Link>
            </Button>
            <div>
              <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">{t('expense.editTitle')}</h1>
              <p className="text-slate-500 text-sm mt-0.5">{t('expense.editDesc')}</p>
            </div>
          </div>
        </div>
      </header>

      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <EditExpenseForm expenseId={expenseId} onSuccess={handleSuccess} />
      </main>
    </div>
  );
}
